const replyMeRouter = {
    path: 'businessArea/reply-me',
    name: 'reply-me',
    meta: {
        title: '回复我的-列表页',
    },
    component: () => import('@/pages/index/home/businessArea/ReplyMe'),
}
export default replyMeRouter



// WEBPACK FOOTER //
// ./src/router/index/replyMe/replyMe.js